import { Select } from '@a0/quantum-product';
import * as React from 'react';
import urljoin from 'url-join';
export var VersionSelector = function (_a) {
    var url = _a.url, version = _a.version, versioning = _a.versioning;
    var options = versioning.versions.map(function (value) { return ({
        value: value,
        text: value,
    }); });
    var handleChange = function (event) {
        var newVersion = event.target.value;
        var newVersionUrl = url.replace("/".concat(version), "/".concat(newVersion));
        // Redirect to the corresponding article in the new target version.
        // NB: We can't do a partial refresh with navigateAction here, because we may end
        // up needing to redirect if the article doesn't exist in the target version.
        document.location = newVersionUrl !== url ? newVersionUrl : urljoin(versioning.baseUrl, version);
    };
    return React.createElement(Select, { label: "Version", value: version, options: options, onChange: handleChange });
};
